/**
 * Documentation page opened by the "Comprendre" button of each screen.
 * The first matching rule wins, so specific paths must come first.
 */
const ROUTE_DOC_SLUGS: { match: RegExp; slug: string }[] = [
  { match: /^\/dashboard/, slug: 'tableau-de-bord' },

  { match: /^\/groups/, slug: 'liste-des-groupes' },
  { match: /^\/group\/create/, slug: 'creer-un-groupe' },
  { match: /^\/group\/edit/, slug: 'modifier-un-groupe' },
  { match: /^\/companies/, slug: 'liste-des-societes' },
  { match: /^\/company\//, slug: 'creer-modifier-une-societe' },
  { match: /^\/branches/, slug: 'liste-des-exploitations' },
  { match: /^\/branch\//, slug: 'creer-modifier-une-exploitation' },

  { match: /^\/users/, slug: 'liste-des-utilisateurs' },
  { match: /^\/user\/create/, slug: 'creer-un-utilisateur' },
  { match: /^\/user\/edit/, slug: 'modifier-un-utilisateur' },

  { match: /^\/vehicules/, slug: 'liste-des-vehicules' },
  { match: /^\/vehicule\//, slug: 'fiche-vehicule' },

  {
    match: /^\/vehicule-check-request\/create/,
    slug: 'demander-une-inspection',
  },
  { match: /^\/vehicule-check-requests/, slug: 'demandes-d-inspection' },
  { match: /^\/vehicule-check-request\//, slug: 'demandes-d-inspection' },
  { match: /^\/vehicule-check\/usage/, slug: 'consommation-des-inspections' },
  { match: /^\/vehicule-check\/view/, slug: 'resultats-d-inspection' },
  { match: /^\/vehicule-check\/edit/, slug: 'resultats-d-inspection' },
  { match: /^\/vehicule-checks/, slug: 'liste-des-inspections' },
  { match: /^\/vehicule-check-email/, slug: 'emails-d-inspection' },

  { match: /^\/check-point/, slug: 'points-d-inspection' },
  { match: /^\/equipment/, slug: 'equipements' },
  { match: /^\/damage/, slug: 'dommages' },
  { match: /^\/vehicule-check-type/, slug: 'types-d-inspection' },
  { match: /^\/email-template/, slug: 'templates-email' },
  { match: /^\/email-settings/, slug: 'automatisation-des-emails' },
  { match: /^\/requested-app-update/, slug: 'mise-a-jour-application' },

  { match: /^\/repair-service/, slug: 'prestations-de-reparation' },
  { match: /^\/repair-costing/, slug: 'grilles-de-chiffrage' },

  { match: /^\/kpi-equipments/, slug: 'kpi-equipements' },
  { match: /^\/kpi-damages/, slug: 'kpi-dommages' },
  { match: /^\/moteur-de-correction-liste/, slug: 'moteur-de-correction' },
  { match: /^\/engine-correction/, slug: 'moteur-de-correction' },
  { match: /^\/endpoints/, slug: 'historique-des-appels-api' },
];

export const getDocSlugForPath = (pathname: string) =>
  ROUTE_DOC_SLUGS.find((rule) => rule.match.test(pathname))?.slug;
